export default __webpack_public_path__ + "static/media/default-banner.7e814cb1.jpg";